import { ResolveAndExecLastRoute } from '../../../core/route/helpers/resolve-and-exec-last-route';
export function ResolveAndExecLastHTTPRoute(route, options) {
    return ResolveAndExecLastRoute(route, options);
}
//# sourceMappingURL=resolve-and-exec-last-http-route.js.map